module.exports = __webpack_public_path__ + "static/fowl-flow-6s-1-64a46c3bc2891358c9b7a2586469cb75.jpg";